module.exports = __webpack_public_path__ + "static/media/file-doc-opacity.3d9f9e7d.svg";